<form [formGroup]="form" (ngSubmit)="submit()" style="max-width:900px">

  <h3 class="fw-bold mb-3">
    {{ rental ? 'Edit Rental' : 'Add New Rental' }}
  </h3>

  <!-- BASIC INFO -->
  <div class="card mb-4 shadow-sm">
    <div class="card-body">
      <h6 class="fw-semibold mb-3">Basic Information</h6>

      <div class="row g-3">

        <div class="col-md-6">
          <label>Title</label>
          <input class="form-control" formControlName="title">
        </div>

        <div class="col-md-6">
          <label>Monthly Rent</label>
          <input type="number" class="form-control" formControlName="price">
        </div>

        <div class="col-md-6">
          <label>Security Deposit</label>
          <input type="number" class="form-control" formControlName="deposit">
        </div>

        <div class="col-md-6">
          <label>Landlord</label>
          <select class="form-select" formControlName="landlordId">
            <option *ngFor="let l of landlords" [value]="l.uid">
              {{ l.landlordName || l.email }}
            </option>
          </select>
        </div>

        <div class="col-12">
          <label>Address</label>
          <input class="form-control" formControlName="address">
        </div>

        <div class="col-12">
          <label class="form-label">Description</label>
        
          <ckeditor
            [editor]="Editor"
            [config]="editorConfig"
            formControlName="description">
          </ckeditor>
        </div>
        

      </div>
    </div>
  </div>

  <!-- PROPERTY DETAILS -->
  <div class="card mb-4 shadow-sm">
    <div class="card-body">
      <h6 class="fw-semibold mb-3">Property Details</h6>

      <div class="row g-3">

        <div class="col-md-4">
          <label>Bedrooms</label>
          <input type="number" class="form-control" formControlName="bedrooms">
        </div>

        <div class="col-md-4">
          <label>Bathrooms</label>
          <input type="number" class="form-control" formControlName="bathrooms">
        </div>

        <div class="col-md-4">
          <label>Sq Ft</label>
          <input type="number" class="form-control" formControlName="sqft">
        </div>

        <div class="col-md-4">
          <label>Status</label>
          <select class="form-select" formControlName="status">
            <option value="pending">Pending</option>
            <option value="available">Available</option>
            <option value="occupied">Occupied</option>
          </select>
        </div>

      </div>
      <label class="form-label">Select Images:</label>
<input
  type="file"
  (change)="onFileSelected($event)"
  multiple
  class="form-control mb-3"
/>

<div *ngIf="previewUrls.length" class="mb-3">
  <h6 class="fw-semibold">Selected Images</h6>

  <div class="d-flex flex-wrap gap-2">
    <img
      *ngFor="let img of previewUrls"
      [src]="img"
      class="rounded border"
      style="width:120px;height:100px;object-fit:cover"
    />
  </div>
</div>
        <h5>Current Images:</h5>
    <div class="d-flex flex-wrap gap-2 mb-3">
      <div *ngFor="let img of rental?.images" class="position-relative">
        <img [src]="img" alt="Rental Image" class="rounded" style="width:120px;height:100px;object-fit:cover;">
        <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0"
          (click)="removeImage(img)">×</button>
      </div>
    </div>
    </div>
  </div>

  <!-- APPLICATION ROUND (ONLY WHEN EDITING) -->
  <div *ngIf="rental" class="card mb-4 shadow-sm">
    <div class="card-body">
      <h6 class="fw-semibold mb-3">Application Round</h6>

      <div *ngIf="!rental.activeRoundId">
        <button
          type="button"
          class="btn btn-success btn-sm"
          (click)="openRound()"
          [disabled]="form.get('status')?.value === 'occupied'"
        >
          Open Application Round
        </button>
        <div *ngIf="form.get('status')?.value === 'occupied'"
         class="text-danger small">
          Applications cannot be opened because this rental is currently occupied.
        </div>
        <div class="text-muted small mt-2">
          Applications are currently closed.
        </div>
      </div>

      <div *ngIf="rental.activeRoundId" class="d-flex align-items-center gap-3">
        <span class="badge bg-success">Round Active</span>

        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="closeRound()"
        >
          Close Round
        </button>
      </div>

    </div>
  </div>

  <!-- ACTIONS -->
  <div class="d-flex gap-2">
    <button class="btn btn-primary" [disabled]="submitting">
      {{ submitting ? 'Saving...' : 'Save Rental' }}
    </button>

    <button type="button" class="btn btn-outline-secondary" (click)="cancel.emit()">
      Cancel
    </button>
  </div>

</form>
